import { composeWithDevTools } from 'redux-devtools-extension';
import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import multi from 'redux-multi';
import rootReducer from '../reducer';

export const Store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunkMiddleware, multi))
);
